import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch } from "vue";
import AlternativeDeliveryForm from "./AlternativeDeliveryForm.vue";
import AlternativeDeliveryFormB2CJapan from "./AlternativeDeliveryFormB2CJapan.vue";
import { injectParentValidator } from "@/core/app.service";
import { useDeliveryMethods } from "./delivery-methods.composable";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryMethodsB2C',
  props: {
    model: null,
    customer: null,
    value: null,
    mandatoryAlternativeDelivery: { type: Boolean },
    taxCalculationErrorMessage: null,
    yubinBangoLoaded: { type: Boolean },
    shouldLoadPickups: { type: Boolean },
    isInvoiceCountryPrimaryCountry: { type: Boolean }
  },
  emits: ["input", "setAlternativeDelivery", "updateTaxTotal", "setDeliveryMethod", "updateShippingCountry", "changeTaxField", "setSelectedPickupShop"],
  setup(__props: any, { emit }: { emit: ({
    (e: "input", value: ShippingAddress): void,
    (e: "setAlternativeDelivery", value: boolean): void,
    (e: "updateTaxTotal"): void,
    (e: "setDeliveryMethod", value: string): void,
    (e: "updateShippingCountry", value: AddressCountryViewObject): void,
    (e: "changeTaxField"): void,
    (e: "setSelectedPickupShop", selectedPickupShop: any, selectedPickupShopId: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    model: CheckoutPageViewModel,
    customer?: InvoiceAddress,
    value?: ShippingAddress,
    mandatoryAlternativeDelivery?: boolean,
    taxCalculationErrorMessage?: string,
    yubinBangoLoaded?: boolean,
    shouldLoadPickups?: boolean,
    isInvoiceCountryPrimaryCountry: boolean,
}





injectParentValidator();

const {
    mount,
    onDeliveryMethodChange,
    requestAlternativePickupShops,
    setAlternativeAddressInLocalStorage,
    updateShippingCountry,
    onPickupShopSelect,
    loadPickupShops,
    setSelectedDeliveryMethod,
    form,
    selectedDeliveryMethod,
    selectedPickupShop,
    alternativeDelivery,
    isLoadingPickupShops,
    pickupShops,
    glsAddress,
    glsPostalCode,
    showAlternativePickupShopsErrorMessage,
    showPickupShopOtherAddressSearch,
    isInvoiceCountryPrimaryCountry
} = useDeliveryMethods<ShippingAddress>(props, emit);

onMounted(mount);

const isCustomerAddressFulfilled = computed(() => {
    return !!props.customer.address && !!props.customer.postalCode;
});

watch(() => props.shouldLoadPickups, () => {
    if (props.shouldLoadPickups) {
        loadPickupShops(true);
    }
});

watch(() => props.isInvoiceCountryPrimaryCountry, () => {
    setSelectedDeliveryMethod();
    isInvoiceCountryPrimaryCountry.value = props.isInvoiceCountryPrimaryCountry;
});

return { __sfc: true,props, emit, mount, onDeliveryMethodChange, requestAlternativePickupShops, setAlternativeAddressInLocalStorage, updateShippingCountry, onPickupShopSelect, loadPickupShops, setSelectedDeliveryMethod, form, selectedDeliveryMethod, selectedPickupShop, alternativeDelivery, isLoadingPickupShops, pickupShops, glsAddress, glsPostalCode, showAlternativePickupShopsErrorMessage, showPickupShopOtherAddressSearch, isInvoiceCountryPrimaryCountry, isCustomerAddressFulfilled, AlternativeDeliveryForm, AlternativeDeliveryFormB2CJapan }
}

})